module.exports = __webpack_public_path__ + "img/245.Kindness_sensitivity.6649feec.svg";